export const USER_TYPE = {
    STUDENT: 'STUDENT',
    TUTOR: 'TUTOR',
}
